import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FiltersBarStyles = styled.div`
  border-bottom: ${(props) =>
    props.$isMenuOpen ? 'none' : 'solid 1px ' + Colors.primary.black.tint};
  height: ${(props) => (props.$isMenuOpen ? '420px' : '60px')};
  overflow-x: scroll;
  overflow-y: visible;
  position: absolute;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  .find-a-home-location-indicator-desktop {
    display: none;
  }
  .filters {
    display: flex;
    margin: 0;
    padding: 0 5px;

    .left-scroll,
    .right-scroll {
      position: sticky;
      width: 50px;
      opacity: 0.8;
      width: 60px;

      > div {
        position: absolute;
        background-color: #fff;
        height: 59px;
        width: 60px; /* required for background */
      }
      svg {
        margin-top: 20px;
        width: 25px;
        height: 25px;
      }
    }

    .left-scroll {
      left: 0;
      > div {
        left: 0;
      }
      svg {
        margin-left: 15px;
      }
    }

    .right-scroll {
      right: -15px;
      > div {
        right: 0;
      }
      svg {
        margin-left: 20px;
      }
    }

    .filter {
      .modal-window {
        width: 300px;
      }
    }
    .find-a-home-location-indicator-mobile {
      .modal-window {
        left: 10px;
      }
    }
    .filter-price {
      .modal-window {
        left: -60px;
      }
    }
    .filter-beds-baths {
      .modal-window {
        left: -100px;
      }
    }
    .filter-features {
      .modal-window {
        left: -100px;
      }
    }
    .filter-size {
      .modal-window {
        left: -180px;
      }
    }
    .filter-name {
      .modal-window {
        left: -220px;
      }

      .bottom-controls {
        border-top: 0;
      }
    }
    .filter {
      padding: 10px 0;

      .filter-button {
        white-space: nowrap;
        background-color: #fff;
        border: solid 1px ${Colors.accent.grey4.standard};
        border-radius: 100px;
        margin: 5px;
        padding: 0 12px;

        &.active {
          color: ${Colors.primary.claytonBlue.standard};
          border-color: ${Colors.primary.claytonBlue.standard};
        }
        &.changed {
          background-color: ${Colors.primary.claytonBlue.standard};
          color: #fff;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    display: flex;
    height: 60px;
    justify-content: space-between;
    overflow-x: visible;
    overflow-y: visible;
    position: relative;
    padding: 0;

    .find-a-home-location-indicator-desktop {
      display: flex;
    }
    .find-a-home-location-indicator-mobile {
      display: none;
    }
    .filters {
      width: 70%;
      padding: 0;
      flex-direction: row;
      justify-content: flex-end;
      margin: 0 28px 0 20px;

      .left-scroll,
      .right-scroll {
        display: none;
      }

      .filter-features {
        .modal-window {
          right: 5px;
        }
      }
      .filter-size {
        .modal-window {
          right: 5px;
        }
      }
      .filter-name {
        .modal-window {
          right: 10px;
        }
      }
    }
  }
`;
